module.exports = __webpack_public_path__ + "img/1102.b87689c7.jpg";